import React, { useState } from "react";
import { Box, Typography, TextField, MenuItem, Button } from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./BulkReprocess.module.css";
import { bulkReprocessApi } from "../../../api/bulkOperationsApi/bulkReprocessApi";

const BulkReprocess: React.FC = () => {
  const [businessUnitName, ] = useState<string>("TCMOne");
  const [subsystemStep, setSubsystemStep] = useState<string>("APF");
  const [documentStreamIds, setDocumentStreamIds] = useState<string>("");
  const [_openSnackbar, set_OpenSnackbar] = useState<boolean>(false);// NOSONAR
  const [_snackbarMessage, set_SnackbarMessage] = useState<string>("");// NOSONAR

  const validateDocumentStreamIds = (ids: string) => {
    if (!ids.trim()) return false;
    // No double spaces
    if (ids.includes("  ")) return false;

    const parts = ids.split(",").map((part) => part.trim());
    return parts.every((part) => /^\d+$/.test(part));
  };

  const handleSubmit = async () => {
    if (!validateDocumentStreamIds(documentStreamIds)) {
      set_SnackbarMessage(
        "Document Stream IDs should not be empty and must be separated by commas without spaces between them."
      );
      set_OpenSnackbar(true);
      return;
    }

    // Create the request body
    const requestBody = {
      BusinessUnitName: businessUnitName,
      SubsystemName: subsystemStep,
      DocumentStreamIDs: documentStreamIds
        .split(",")
        .map((id) => parseInt(id.trim(), 10)),
    };

    try {
      await bulkReprocessApi.reprocess(requestBody);
      set_SnackbarMessage("Reprocess completed successfully!");
      set_OpenSnackbar(true);
    } catch (error) {
      set_SnackbarMessage("An error occurred while reprocessing.");
      set_OpenSnackbar(true);
    }
  };

  const handleCancel = () => {
    setSubsystemStep("APF");
    setDocumentStreamIds("");
  };

  return (
    <Container fluid>
      <Row>
        <Col xs={12} md={8} lg={6} className={styles.marginLeftResponsive}>
          <Box>
            <Typography variant="h6" gutterBottom>
              Bulk Reprocess
            </Typography>

            <TextField
              select
              label="Subsystem Step"
              value={subsystemStep}
              onChange={(e) => setSubsystemStep(e.target.value)}
              fullWidth
              margin="normal"
            >
              <MenuItem value="APF">APF</MenuItem>
              <MenuItem value="VIS">VIS</MenuItem>
            </TextField>

            <TextField
              label="Document Stream IDs"
              multiline
              rows={5}
              value={documentStreamIds}
              onChange={(e) => setDocumentStreamIds(e.target.value)}
              placeholder="Enter Document Stream IDs, separated by commas"
              fullWidth
              margin="normal"
            />

            <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Reprocess
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Col>
      </Row>
    </Container>
  );
};

export default BulkReprocess;
